module.exports = __webpack_public_path__ + "img/car_parts.8b08b3ca.jpg";